module.exports = __webpack_public_path__ + "img/1.77f4a9d2.svg";